import SharepointUpload from '../components/psc/lib/SharepointUpload'

const DocumentSharepointUpload = () => {
    return (
        <SharepointUpload
            entityType="Document"
            apiPath="documents"
            statusField="document_status"
        />
    )
};

export default DocumentSharepointUpload
